import { createParser } from "nuqs";
import { z } from "zod";

const toBase64Url = (str: string) =>
  btoa(str).replace(/\+/g, "-").replace(/\//g, "_").replace(/=/g, "");

const fromBase64Url = (str: string) =>
  atob(str.replace(/-/g, "+").replace(/_/g, "/"));

export const parseAsBase64Json = <T>(schema: z.ZodType<T>) =>
  createParser<T>({
    parse(value) {
      try {
        return schema.parse(JSON.parse(fromBase64Url(value)));
      } catch {
        return null;
      }
    },
    serialize(value) {
      return toBase64Url(JSON.stringify(value));
    }
  });
